import _extends from "@babel/runtime-corejs3/helpers/extends";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import { features } from '@kdcloudjs/table';

function useFilter(pipeline, filter) {
  if (filter) {
    pipeline.use(_filterInstanceProperty(features).call(features, _extends({}, filter)));
  }
}

export default useFilter;